{
  "version": 1,
  "asset_id": "4c025340-6a64-49af-aab4-2563a8371cff",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/4c025340-6a64-49af-aab4-2563a8371cff/gallery-12.JPG",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/4c025340-6a64-49af-aab4-2563a8371cff/gallery-12.JPG",
  "original_filename": "gallery-12.JPG",
  "size": 569643,
  "content_type": "image/jpeg",
  "created_at": "2026-07-01T04:23:03Z"
}
